import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchTvVideos } from "../../services/tvService";
import { timeDifference } from "../../utils/timeUtils";

/** Right-sidebar teaser: the 3 newest TV videos, linking to /video. */
export default function TvSidebar({ count = 3 }) {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchTvVideos(count).then((data) => {
      if (cancelled) return;
      setVideos(data.slice(0, count));
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [count]);

  // Nothing to tease → keep the sidebar clean.
  if (!loading && videos.length === 0) return null;

  return (
    <div className="rounded-card border border-line bg-surface p-5">
      <h3 className="mb-3.5 font-head text-[12px] font-bold uppercase tracking-wider text-sub">
        Video të fundit
      </h3>
      {loading ? (
        <p className="text-[12.5px] text-sub">Po ngarkohen videot…</p>
      ) : (
        <>
          {videos.map((v) => (
            <a
              key={v.videoId}
              href={v.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex gap-3 border-t border-line py-2.5 first:border-t-0 hover:bg-chip/40"
            >
              <div className="relative aspect-video w-[104px] shrink-0 overflow-hidden rounded-md bg-chip">
                <img
                  src={v.thumbnail}
                  alt=""
                  referrerPolicy="no-referrer"
                  className="h-full w-full object-cover transition group-hover:scale-105"
                  onError={(e) => {
                    e.target.src = "/fallback.jpg";
                  }}
                />
                <span className="absolute inset-0 grid place-items-center">
                  <span className="grid h-7 w-7 place-items-center rounded-full bg-black/60 text-[11px] text-white transition group-hover:bg-brand">
                    ▶
                  </span>
                </span>
              </div>
              <div className="min-w-0 flex-1">
                <p className="line-clamp-2 text-[13px] font-semibold leading-snug text-ink">
                  {v.title}
                </p>
                <p className="mt-1 text-[11.5px] text-sub">
                  <span className="font-semibold text-brand">{v.channel}</span>
                  {v.publishedAt && <> · {timeDifference(v.publishedAt)}</>}
                </p>
              </div>
            </a>
          ))}
          <Link
            to="/video"
            className="mt-3 block text-right font-head text-[12.5px] font-bold text-brand hover:underline"
          >
            Shiko të gjitha videot →
          </Link>
        </>
      )}
    </div>
  );
}
